export const pages = ['page1', 'page2', 'page3', 'page4'] as const;

export type Page = (typeof pages)[number];
type Component = 'welcomePage' | 'fleetAssistantOverview' | 'assistantFunctionality' | 'frequentlyAskedQuestions';

export type PageProps = {
  title: string;
  translation: string;
  componentId: Component;
};

type PageToContent = {
  [key in Page]: PageProps;
};

export type ComponentToElement = {
  [key in Component]: JSX.Element;
};

export const pageToContent: PageToContent = {
  page1: {
    title: 'welcome',
    translation: 'getStartedPage.welcome.label',
    componentId: 'welcomePage',
  },
  page2: {
    title: 'what-is',
    translation: 'getStartedPage.whatIsFleetAssistant.label',
    componentId: 'fleetAssistantOverview',
  },
  page3: {
    title: 'how-it-works',
    translation: 'getStartedPage.howVirtualAssistantWorks.label',
    componentId: 'assistantFunctionality',
  },
  page4: {
    title: 'frequently-asked-questions',
    translation: 'getStartedPage.frequentlyAskedQuestions.label',
    componentId: 'frequentlyAskedQuestions',
  },
} as const;
